import { jquery } from 'jquery';
import $ from 'jquery';

class UtilController {
    constructor() {
    }

    getPageId() {
        let pageid_ = document.querySelector('[data-pageid]');
        if (pageid_ !== undefined) {
            return pageid_.getAttribute('data-pageid');
        }
        return undefined;
    }

    getBasePath() {
        let index_ = document.querySelector('link[rel=index]');
        if (index_ !== undefined) {
            return index_.href;
        }
        return undefined;
    }

    isset( obj ) {
        if (obj != undefined && obj != null && obj.length > 0) {
            return true;
        }
        return false;
    }

    wait( time ) {
        let dfd_ = $.Deferred();
        setTimeout(function () {
            dfd_.resolve();
        }, time);
        return dfd_.promise();
    }

    animation( target, obj, duration, easing ) {
        let dfd_ = $.Deferred();

        $( target ).stop(true, false).animate( obj, {
            duration : duration,
            easing : easing,
            complete : function () {
                dfd_.resolve();
            }
        });

        return dfd_.promise();
    }

    checkDevice() {
        if ( window.matchMedia( '(min-width: 961px)' ).matches ) {
            return 'PC';
        } else {
            return 'SP';
        }
    }
}

export default new UtilController();
